$(document).ready(function(){
	var $product = $('.product-handle').val(),
	$productList = localStorage.getItem('products'),
	$add = true;
	if($productList != null) {
		if($productList.indexOf(',') != -1) {
			$productList = $productList.split(',');
			$i = 0;
			$.each($productList, function(){
				if($productList[$i] == $product) {
					$add = false;
				}
				$i++;
			});
		} else {
			if($productList == $product) {
				$add = false;
			}
		}
	}
	if($add == true) {
		if($productList == null) {
			localStorage.setItem('products', $product);
		} else {
			$product = $productList + ',' + $product;
			localStorage.setItem('products', $product);
		}
	}
});